import { BOOKING_KM_OPTIONS } from '@yescapa-dev/ysc-api-js/modern'

export function assertKilometersOption(x: unknown): asserts x is BOOKING_KM_OPTIONS {
  return assertEnumValue(BOOKING_KM_OPTIONS, x)
}
